import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
import store from './store/store'

import axios from 'axios'
import VueMobileDetection from 'vue-mobile-detection'
import * as VueGoogleMaps from 'gmap-vue'
import './registerServiceWorker'

Vue.use(VueMobileDetection)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBDUWW-U8_bbYAGUErWYcaSL73alwwreII',
    region: 'SV',
    language: 'sv',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})


//to be able to display snackbar alerts all over the app
export const snackBarBus = new Vue()

//Vue.config.productionTip = false
axios.defaults.baseURL = 'https://api.chaffis.se/rest'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8'

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

